import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout, Button, message, Space } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";
import SignatureCanvas from "react-signature-canvas";

import {
  getMemberDigitalApi,
  getDigitalApplicationApi,
} from "../../services/Member/MemberApis";
import { addMemberSignatureApi } from "../../services/Member/MemberApis";
import { sendDigitalDocumentApi } from "../../services/Document/DocumentApis";

const { Content } = Layout;

const MemberSignaturePage: React.FC = () => {
  const navigate = useNavigate();
  const { memberId }: any = useParams();

  const [isActive, setActive] = useState(true);
  const [content, setContent] = useState();
  const [member, setMember] = useState<any>({});

  const signatureRef = useRef<SignatureCanvas | null>(null);

  const parser = new DOMParser();
  const doc = parser.parseFromString(content || "", "text/html");
  const bodyContent = doc.body.innerHTML || "";

  useEffect(() => {
    getMemberDigitalApi(String(memberId))
      .then((res: any) => {
        setMember(res.data);
        getDigitalApplicationApi(
          String(memberId),
          res.data.Group.ApplicationDocument
        )
          .then((res: any) => {
            setContent(res.data.html);
            setActive(false);
          })
          .catch((err: any) => {
            console.log(err);
          });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, []);

  const handleClear = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  const handleSave = () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      const signatureData = signatureRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setActive(true);
      getMemberDigitalApi(String(memberId))
        .then((res: any) => {
          if (!res?.success || !res?.data?.Group?.ApplicationDocument) {
            setActive(false);
            message.error(
              res?.message ||
                "Unable to load member application details. Please try again."
            );
            return;
          }
          addMemberSignatureApi(memberId, res.data.Group.ApplicationDocument, {
            Signature: signatureData,
          })
            .then((res) => {
              if (res?.success) {
                navigate(`/members/success/${memberId}`);
                setActive(false);
                message.success("Successfully added signature.");
              } else {
                setActive(false);
                message.error(
                  res?.message ||
                    "Error occurred while saving signature. Please try again."
                );
              }
            })
            .catch((err: any) => {
              console.log(err);
              setActive(false);
              message.error(
                err?.message ||
                  err?.response?.data?.message ||
                  "Error occurred while saving signature. Please try again."
              );
            });
        })
        .catch((err: any) => {
          console.log(err);
          setActive(false);
          message.error(
            err?.message ||
              err?.response?.data?.message ||
              "Unable to load member application details. Please try again."
          );
        });
    } else {
      message.warning("Please provide a signature before saving.");
    }
  };

  // const handleSubmit = () => {
  //   getMemberDigitalApi(String(memberId))
  //     .then((res: any) => {
  //       sendDigitalDocumentApi(res.data.Group.ApplicationDocument, memberId)
  //         .then((res) => {
  //           if (res.success) {
  //             navigate(`/members/success/${memberId}`);
  //             setActive(false);
  //           } else {
  //             message.error("Error occurred, Please try again.");
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //           setActive(false);
  //         });
  //     })
  //     .catch((err: any) => {
  //       console.log(err);
  //     });
  // };

  return (
    <LoadingOverlay active={isActive} spinner={<LoadingOutlined />}>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout className="site-layout">
          <Content
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              background: "#fff",
              padding: "16px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                width: "100%",
                maxWidth: "500px",
                padding: "16px",
              }}
            >
              {member.Group?.CompanyLogo && (
                <img
                  src={member.Group.CompanyLogo}
                  alt="Group Logo"
                  style={{
                    marginBottom: "24px",
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              )}
              <h3 style={{ marginBottom: "24px", fontSize: "1.2rem" }}>
                Please review your application details below. Confirm that all
                information is accurate, then sign on the device to complete
                your application.
              </h3>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  dangerouslySetInnerHTML={{ __html: bodyContent }}
                  style={{
                    marginBottom: "24px",
                    width: "100%",
                  }}
                />
              </div>

              <h4 style={{ fontSize: "1.0rem" }}>Signature</h4>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "16px",
                  border: "1px solid #e8e8e8",
                  padding: "8px",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    style: {
                      width: "100%",
                      height: "150px",
                    },
                  }}
                />
              </div>
              <Space
                style={{
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Space>
                  <Button onClick={handleClear}>Clear</Button>
                  <Button type="primary" onClick={handleSave}>
                    Submit
                  </Button>
                </Space>
                {/* <Button
                  type="primary"
                  onClick={handleSubmit}
                  style={{ marginTop: "8px" }}
                  block
                  disabled={!memberSignature} // Disable if signature hasn't been saved
                >
                  Submit
                </Button> */}
              </Space>
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default MemberSignaturePage;
